import {
  ATypeMainHead,
  ATypeCardView,
  BTypeBreadCrumb,
  colors,
  ATypeMap,
  FullWidthTwinButton,
  call,
  ATypeNationalMeritSummary,
  ATypeNationalMeritDescription,
  GOI_WEB_URL,
  customEvent,
} from "goi_common";
import { GetStaticPaths, GetStaticProps } from "next";

import React from "react";
import { ParlorDetailProps } from "goi_common";
import { parlorRegion } from "@/constants/parlorRegion";
import { Box, Stack } from "@mui/material";
import Head from "next/head";
import facilities from "goi_common/src/constants/facilities_detail.json";

const { regionColor, targetSidos } = parlorRegion;

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = facilities
    .filter((f) => targetSidos.includes(f.sido) && f.is_public)
    .map((f) => ({
      params: {
        companyname: f.companyname,
      },
    }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const companyname = params?.companyname;
  let p_facility;
  let district;
  let name = "";
  let description = "";

  if (companyname) {
    p_facility = facilities.find((f) => f.companyname === companyname);
    if (p_facility) {
      name = p_facility.companyname;

      district = p_facility.address.slice(0, 2);
      if (p_facility.address.split(" ")[0].length == 4)
        district = p_facility.address[0] + p_facility.address[2];

      description = `대구경북 지역 국가유공자 공설 장지 혜택 및 안내. 대구경북 지역 국가유공자 공설 장지. 대구경북 지역 국가유공자 공설 장지 혜택. 대구경북 지역 국가유공자 장지 우선 안치. 대구경북 지역 국가유공자 장례 관련 상담.`;
    }
  }

  return {
    props: {
      defaultPFacility: p_facility,
      pageDescription: description,
      pageKeywords: `${p_facility?.companyname}, ${p_facility?.companyname} 국가유공자, ${district} 국가유공자 장례, 국가유공자 장례 얼마,`,
      pageOgTitle: `${p_facility?.companyname} 국가유공자 장지 비용 안내 | 대구경북장례정보포털`,
      pageOgDescription: description,
      pageOgImage: p_facility?.images[0].url || "",
      hasError: !p_facility,
    },
  };
};

export default function companyname({
  defaultPFacility,
  pageOgTitle,
}: {
  defaultPFacility: ParlorDetailProps;
  pageOgTitle: string;
}) {
  const regionPFacilities = facilities.filter((p) =>
    targetSidos.includes(String(p.sido)) && p.is_public
  );

  const carouselItems = regionPFacilities.map((res, i) => {
    return {
      "@type": "ListItem",
      name: `(비용안내) ${res.companyname}`,
      image: `${res.images[0].url}`,
      url: `https://dggb-portal.funeralblog.co.kr/national-merit/public-facility/${res.companyname}/`,
      position: i + 1,
    };
  });

  const carouselRichSearch =
    regionPFacilities.length > 6
      ? {
          "@context": "http://schema.org",
          "@type": "ItemList",
          itemListElement: carouselItems,
        }
      : {};
  return (
    <Stack>
      <Head>
        <title>{pageOgTitle}</title>
        {regionPFacilities.length > 5 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(carouselRichSearch),
            }}
          />
        )}
      </Head>

      <BTypeBreadCrumb
        firstItem={{
          text: `대구 경북 국가유공자 장례헬프센터`,
          href: `/national-merit/`,
        }}
      />
      <ATypeMainHead
        defaultParlor={defaultPFacility}
        title={`${defaultPFacility.companyname}`}
        managed_type={defaultPFacility.managed_type}
        address={defaultPFacility.address}
      />

      <Box style={{ padding: "12px 20px" }} className="subtitle_21_b">
        {defaultPFacility.companyname}
        <br />
        국가유공자에게 제공되는 혜택
      </Box>

      <Stack padding="20px 20px 40px" gap="24px">
        <ATypeNationalMeritDescription />
        <ATypeNationalMeritSummary mainColor={regionColor} />
        <FullWidthTwinButton
          firstBtn={{
            isGoiCall: true,
            text: "상담하기",
            onClick: () => {
              call("1666-9784");
              customEvent({
                domain: "dggb",
                path: "nat_merit_facility",
                trigger_and_target: "goi_call",
              });
            },
          }}
          secondBtn={{
            text: "비용 알아보기",
            href: `${GOI_WEB_URL}?utm_source=dogsound` + "/match/request/?utm_source=dogsound",
            onClick: () => {
              customEvent({
                domain: "dggb",
                path: "nat_merit_facility",
                trigger_and_target: "uv_mth_req",
              });
            },
          }}
          backgroundColor={regionColor.c300}
        />
        <Box className="subtitle_14_b" textAlign="center">
          상담을 통해 자세한 국가 유공자 장례 혜택을 안내드립니다.
        </Box>
      </Stack>

      <Stack
        style={{ background: regionColor.c100 }}
        padding="40px 20px"
        marginBottom="40px"
        gap="8px"
      >
        <ATypeMap defaultParlor={defaultPFacility} />
      </Stack>
      <Stack padding="0px 20px" marginBottom="40px" gap="8px">
        <h3 className="button_16_sb">대구 · 경북 지역 장지</h3>
        {regionPFacilities.map((res) => (
          <ATypeCardView
            key={res.companyname}
            name={res.companyname}
            href={`/national-merit/public-facility/${res.companyname}/`}
            descriptions={["국가유공자 우선 안치"]}
            imgSrc={res.images[0]?.url ? res.images[0].url : ""}
            event={{
              domain: "dggb",
              path: "nat_merit_facility",
              trigger_and_target: "uv_prlr_detail",
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
}
